/** DSN Sentry (bundle client — pas de variable d’environnement). */
export const SENTRY_DSN =
    "https://be7d3e451e514d92a708519718164d50@o342045.ingest.us.sentry.io/4509197683326976"
